import React from 'react';
import Wrapper from './Wrapper';

const Comment = Wrapper(props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.60008 6.06669H13.4001M4.60008 9.00002H11.4445M15.3556 13.4H8.51119L4.60008 16.3334V13.4H2.64453C2.3852 13.4 2.1365 13.297 1.95313 13.1136C1.76976 12.9303 1.66675 12.6816 1.66675 12.4222V2.64446C1.66675 2.38514 1.76976 2.13644 1.95313 1.95307C2.1365 1.7697 2.3852 1.66669 2.64453 1.66669H15.3556C15.615 1.66669 15.8637 1.7697 16.047 1.95307C16.2304 2.13644 16.3334 2.38514 16.3334 2.64446V12.4222C16.3334 12.6816 16.2304 12.9303 16.047 13.1136C15.8637 13.297 15.615 13.4 15.3556 13.4Z"
      stroke="#535B64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
export default Comment;
